const m = require('minthril');
const { component } = require('../component');
const { createAppController } = require('../controllers/app');
const { PageRouter } = require('./router');

const Pages = component((vnode, emit) => {
  const controller = createAppController(() => emit('redraw'));

  return {
    view: () => m(PageRouter, { controller })
  };
});

module.exports = { Pages };
